import moment from 'moment';
import _each from 'lodash/each';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import jQuery from 'jquery';

import config from 'src/config';
import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $rootScope, $timeout, $window, $state, $stateParams, $sce, utilsService, jsSdkEvent, jsSdkVenue,
  jsSdkCuratedList, imgix, $http, $uibModal, $filter, fb, loggerService, favoritesService, eventHelpersService, metaTagService, trackingService, $location, jsSdkConfig) {

  let eventId;

  if ($stateParams.seoPathname) {
    eventId = $stateParams.seoPathname.split('-').pop();
  } else if ($stateParams.eventId) {
    eventId = $stateParams.eventId;
  } else {
    return $state.go('app.404');
  }

  $scope.showBackBtn = !!$stateParams.back;
  $scope.backId = $stateParams.back;
  $scope.backName = $stateParams.backName;

  const eventPromise = jsSdkEvent.readById(eventId, {
    fields: [
      'name',
      'seoPathname',
      'details',
      'tags',
      'images',
      'active',
      'date',
      'dateStart',
      'dateEnd',
      'venue(name,location,seoPathname,marketingOptInText,showMarketingOptIn,details.minAge, trackingFacebookPixelId)',
      'timezone',
      'isMapWidgetEnabled',
      'externalSellingLink',
      'inventoryNote',
      'trackingFacebookPixelId',
      'performers'
    ].join(',')
  });

  eventPromise
    .then(response => {
      $scope.initialize(response);

      trackingService.trackEvent(SEGMENT_EVENTS.ViewedEvent, {
        venueId: $scope.event.venue.id,
        venueName: $scope.event.venue.name,
        eventId: $scope.event.id,
        eventName: $scope.event.name
      });

      if (config.NODE_ENV === 'production') {
        const trackingData = {
          content_type: 'product',
          content_ids: [
            $scope.event.venue.id
          ],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'ViewContent', trackingData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'ViewContent', trackingData);

        if ($scope.event.venue.trackingFacebookPixelId) {
          $window.fbq('init', $scope.event.venue.trackingFacebookPixelId);
          $window.fbq('init', $scope.event.venue.trackingFacebookPixelId);
          $window.fbq('trackSingle', $scope.event.venue.trackingFacebookPixelId, 'ViewContent', trackingData);
        }
      }

      $timeout(() => {
        const client = $location.search().client || 'web';

        if ($scope.event.isMapWidgetEnabled) {
          const inventoryListMapWidget = new window.TablelistWidgets.widgets.InventoryListMapWidget('#inventory-list-map-widget');

          inventoryListMapWidget.init({
            venueId: $scope.event.venue.id,
            eventId: $scope.event.id,
            date: $scope.event.date,
            client,
            theme: 'theme-light',
            attributionId: jsSdkConfig.attributionId || 'TABLELIST',
            affiliateId: $rootScope.affiliateId,
            trackingId: $rootScope.trackingId,
            disableInlineCheckout: true,
            checkoutUrl: config.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
            onInventoryAddedToCart(inventory) {
              if (config.NODE_ENV === 'production') {
                const fbqData = {
                  content_type: 'product',
                  value: inventory.price,
                  currency: 'USD',
                  content_ids: [
                    inventory.venue
                  ],
                  referrer: document.referrer,
                  userAgent: navigator.userAgent,
                  language: navigator.language
                };

                $window.fbq('init', '1606722376242558');
                $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
                $window.fbq('init', '316401409092218');
                $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);

                if ($scope.event.trackingFacebookPixelId) {
                  $window.fbq('init', $scope.event.trackingFacebookPixelId);
                  $window.fbq('trackSingle', $scope.event.trackingFacebookPixelId, 'AddToCart', fbqData);
                }
              }
            }
          });
        } else {
          let inventoryListWidget;

          if (jQuery(window).width() < 992) {
            inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-xs');
          } else {
            inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-lg');
          }

          inventoryListWidget.init({
            venueId: $scope.event.venue.id,
            eventId: $scope.event.id,
            date: $scope.event.date,
            client,
            theme: 'theme-light',
            attributionId: jsSdkConfig.attributionId || 'TABLELIST',
            affiliateId: $rootScope.affiliateId,
            trackingId: $rootScope.trackingId,
            disableInlineCheckout: true,
            checkoutUrl: config.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
            onInventoryAddedToCart(inventory) {
              if (config.NODE_ENV === 'production') {
                const fbqData = {
                  content_type: 'product',
                  value: inventory.price,
                  currency: 'USD',
                  content_ids: [
                    inventory.venue
                  ],
                  referrer: document.referrer,
                  userAgent: navigator.userAgent,
                  language: navigator.language
                };

                $window.fbq('init', '1606722376242558');
                $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
                $window.fbq('init', '316401409092218');
                $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);

                if ($scope.event.trackingFacebookPixelId) {
                  $window.fbq('init', $scope.event.trackingFacebookPixelId);
                  $window.fbq('trackSingle', $scope.event.trackingFacebookPixelId, 'AddToCart', fbqData);
                }
              }
            }
          });
        }
      });
    })
    .catch(() => {
      $state.go('app.404', {
        message: 'Uh oh. The event you are looking for is no longer available.',
        target: `/e/${eventId}`
      });
    });

  $scope.initialize = function(event) {
    $scope.event = event;

    setTags(event);
    setPlugins(event);
    setAddress(event);

    const venueId = _get($scope, 'event.venue.id');

    _getEvents(venueId);
    _getCuratedLists(event.id);

    fb.logEvent(fb.events().VIEWED_CONTENT, $scope.event.id);

    const venue = _get($scope, 'event.venue.name');

    const venueString = (venue) ? ' at ' + venue : ""; //eslint-disable-line

    const metaTitle = `Buy Tickets and Tables to ${event.name}${venueString}`;
    const metaDesc = `Buy tickets, tables and packages at  ${event.name}${venueString}`;

    metaTagService.set({
      title: metaTitle,
      description: metaDesc,
      facebookImage: _get($scope, ['event', 'primaryImage', 'xlarge']),
      canonicalPath: `/e/${$scope.event.seoPathname}`
    });

    $scope.shareBarConfig = {
      url: utilsService.createUrl(`/e/${$scope.event.seoPathname}`),
      message: `Join me at ${$scope.event.name}`
    };
  };

  $scope.imgix = function(src, w, h) {
    if (!src) return null;

    return imgix.url(src, {
      width: w,
      height: h
    });
  };

  $scope.isPast = function() {
    if (!$scope.event) return null;

    const start = moment($scope.event.date, 'x');
    const now = moment();
    const diff = now.diff(start, 'hours');

    return (diff >= 24);
  };

  $scope.canBookNow = function() {
    if (!$scope.event) return null;

    return $scope.event.active;
  };

  $scope.getEventOpenSentence = function(event) {
    if (!event) return;

    const now = moment();
    const nowDate = now.get('date');

    const eventDate = moment($filter('localize')(event.date));

    let opensAt = '';

    if (nowDate === eventDate.get('date')) {
      opensAt = (eventDate.get('hours') >= 18 ? 'Tonight' : 'Today') + ' at ' + $scope.event.name; //eslint-disable-line
    } else if (nowDate === eventDate.add(1, 'days').get('date')) {
      opensAt = `Tomorrow at ${$scope.event.name}`;
    } else {
      opensAt = `${eventDate.format('dddd MMMM DD')} ${$scope.event.name}`;
    }

    event.opensAt = opensAt;
  };

  $scope.eventDateString = function(event) {
    if (!event || !event.date) return '';

    const eventDate = moment.utc(event.date).startOf('day');

    $scope.date = eventDate;

    const now = moment();
    const today = now.clone().startOf('day');
    const tomorrow = now.clone().add(1, 'days').startOf('day');

    if ($scope.isPast()) {
      return `${eventDate.format('M/D/YYYY')} at `;
    }

    if (eventDate.isSame(today, 'd')) {
      return `Tonight, ${eventDate.format('M/D')} at `;
    }

    if (eventDate.isSame(tomorrow, 'd')) {
      return `Tomorrow, ${eventDate.format('M/D')} at `;
    }

    return `${eventDate.format('dddd, M/D')} at `;
  };

  function setTags(event) {
    const musicTags = _filter(event.tags, function(tag) {
      return tag.key === 'MUSIC';
    });

    const crowdTags = _filter(event.tags, function(tag) {
      return tag.key === 'CROWD';
    });

    const okDressCodeTags = _filter(event.tags, function(tag) {
      return tag.key === 'DRESS_CODE_OK';
    });

    const notOkDressCodeTags = _filter(event.tags, function(tag) {
      return tag.key === 'DRESS_CODE_NOT_OK';
    });

    const userDefinedTags = _filter(event.tags, function(tag) {
      return tag.key === 'USER_DEFINED';
    });

    //tags
    if (musicTags && musicTags.length) {
      $scope.event.musicTags = musicTags;
    }
    if (crowdTags && crowdTags.length) {
      $scope.event.crowdTags = crowdTags;
    }
    if (okDressCodeTags && okDressCodeTags.length) {
      $scope.event.okDressCodeTags = okDressCodeTags;
    }
    if (notOkDressCodeTags && notOkDressCodeTags.length) {
      $scope.event.notOkDressCodeTags = notOkDressCodeTags;
    }
    if (userDefinedTags && userDefinedTags.length) {
      $scope.event.userDefinedTags = userDefinedTags;
    }
  }

  function setPlugins(event) {
    $scope.event.details = event.details || {
      social: {}
    };
    $scope.event.details.soundcloud = event.details.soundcloud ? $sce.trustAsResourceUrl(event.details.soundcloud) : '';
    $scope.event.details.youtube = event.details.youtube ? $sce.trustAsResourceUrl(getYoutubeUrl(event.details.youtube)) : '';
  }

  function setAddress(event) {
    const address = _get(event, 'venue.location.address');

    if (!address) return;

    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(address));

    $scope.googleMapsDirectionsUrl = (address.address) ? 'http://www.google.com/maps/dir//' + address.address.replace(/ /g, '+') + '+' + address.city + '+' + address.state + '+' + address.zip : null; //eslint-disable-line
  }

  function getYoutubeUrl(url) {
    if (url.indexOf('embed') >= 0) return url;
    let embedUrl = 'https://www.youtube.com/embed/';
    const query = urlQuery(url);

    embedUrl += query.v;

    return embedUrl;
  }

  function urlQuery(url) {
    const query = {};
    const queryString = url.split('?').pop();
    const queryParts = queryString.split('&');

    _each(queryParts, function(part) {
      const parts = part.split('=');
      const key = parts[0];
      const val = parts[1];
      query[decodeURIComponent(key)] = decodeURIComponent(val);
    });

    return query;
  }

  function _getEvents(venueId) {
    if (!venueId) {
      $scope.loadingEvents = false;
      return;
    }

    const start = moment().toDate().getTime();
    const end = moment().add(4, 'month').toDate().getTime();

    jsSdkEvent.listByVenueId(venueId, {
      start: start,
      end: end,
      sort: 'date',
      limit: 6,
      fields: 'name,date,description,images,seoPathname'
    }).then(function success(response) {

      _map(response, function(event) {
        event.image = _get(event, 'primaryImage.filename', 'https://assets.tablelist.com/www/images/event-default-poster-v1.2.jpg');
        return event;
      });

      // Sort events by date.
      $scope.events = response;

      $scope.loadingEvents = false;
    });
  }

  function _getCuratedLists(eventId2) {
    if (!eventId2) return;

    jsSdkCuratedList.listByEventId(eventId2).then(function(resp) {
      $scope.curatedLists = resp;
    });
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  '$window',
  '$state',
  '$stateParams',
  '$sce',
  'utilsService',
  'jsSdk.event',
  'jsSdk.venue',
  'jsSdk.curatedList',
  'jsSdk.imgix',
  '$http',
  '$uibModal',
  '$filter',
  'tl.facebook',
  'loggerService',
  'favoritesService',
  'eventHelpersService',
  'metaTagService',
  'trackingService',
  '$location',
  'jsSdk.config'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/event/eventCtrl.js